import { EnumDescriptions } from '@/app/shared/utils';
import { i18n } from '@/plugins';

export enum ContractReasonCancellation {
  CancelledByAudit = 1,
  UnemployedCustomer = 2,
  CustomerInterested = 3,
  CustomerInsurance = 4,
  UndueCharges = 5,
  OtherFormOfPayment = 6,
  LegalProceedings = 7,
  AcquirerComplaint = 8,
  InternetComplaint = 9,
  Sinister = 10,
  RequestedByEmail = 11,
  Subsidies = 12,
  SaleWithoutAuthorization = 13,
  TestSale = 14,
  FinishedWithoutChange = 15,
  PreChargeBack = 16,
  Other = 98,
  Undefined = 99,
}
EnumDescriptions.setDescriptions(ContractReasonCancellation, [
  i18n.t('enums.contractReasonCancellation.CancelledByAudit'),
  i18n.t('enums.contractReasonCancellation.UnemployedCustomer'),
  i18n.t('enums.contractReasonCancellation.CustomerInterested'),
  i18n.t('enums.contractReasonCancellation.CustomerInsurance'),
  i18n.t('enums.contractReasonCancellation.UndueCharges'),
  i18n.t('enums.contractReasonCancellation.OtherFormOfPayment'),
  i18n.t('enums.contractReasonCancellation.LegalProceedings'),
  i18n.t('enums.contractReasonCancellation.AcquirerComplaint'),
  i18n.t('enums.contractReasonCancellation.InternetComplaint'),
  i18n.t('enums.contractReasonCancellation.Sinister'),
  i18n.t('enums.contractReasonCancellation.RequestedByEmail'),
  i18n.t('enums.contractReasonCancellation.Subsidies'),
  i18n.t('enums.contractReasonCancellation.SaleWithoutAuthorization'),
  i18n.t('enums.contractReasonCancellation.TestSale'),
  i18n.t('enums.contractReasonCancellation.FinishedWithoutChange'),
  i18n.t('enums.contractReasonCancellation.PreChargeBack'),
  i18n.t('enums.contractReasonCancellation.Other'),
  i18n.t('enums.contractReasonCancellation.Undefined'),
]);
